module.exports = __webpack_public_path__ + "img/mongo.36421632.png";